module.exports = __webpack_public_path__ + "img/flakes.e85c94cd.png";